/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvestmentDetailsFeeDisinvestmentAssetSplitViewModel
 */
export interface InvestmentDetailsFeeDisinvestmentAssetSplitViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsFeeDisinvestmentAssetSplitViewModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsFeeDisinvestmentAssetSplitViewModel
     */
    assetCode: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsFeeDisinvestmentAssetSplitViewModel
     */
    splitPercentage?: number;
}

/**
 * Check if a given object implements the InvestmentDetailsFeeDisinvestmentAssetSplitViewModel interface.
 */
export function instanceOfInvestmentDetailsFeeDisinvestmentAssetSplitViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "assetCode" in value;

    return isInstance;
}

export function InvestmentDetailsFeeDisinvestmentAssetSplitViewModelFromJSON(json: any): InvestmentDetailsFeeDisinvestmentAssetSplitViewModel {
    return InvestmentDetailsFeeDisinvestmentAssetSplitViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsFeeDisinvestmentAssetSplitViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsFeeDisinvestmentAssetSplitViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'assetCode': json['AssetCode'],
        'splitPercentage': !exists(json, 'SplitPercentage') ? undefined : json['SplitPercentage'],
    };
}

export function InvestmentDetailsFeeDisinvestmentAssetSplitViewModelToJSON(value?: InvestmentDetailsFeeDisinvestmentAssetSplitViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'AssetCode': value.assetCode,
        'SplitPercentage': value.splitPercentage,
    };
}

